import { useQuery } from '@tanstack/react-query';
import { fetchBilling } from './api';
import type { BillingDateRange, BillingSummary } from './types';

/**
 * Ключи запросов для биллинга.
 */
export const billingKeys = {
  all: ['billing'] as const,
  summary: () => [...billingKeys.all, 'summary'] as const,
};

/**
 * Хук получения сводки биллинга за выбранный диапазон дат.
 * Возвращает строки `dailyUsage`, попадающие в `[from, to]`, и суммарный расход минут.
 * Источник — общий мок-массив за все доступные периоды; фильтрация выполняется на клиенте.
 */
export const useBilling = (dateRange: BillingDateRange) =>
  useQuery({
    queryKey: billingKeys.summary(),
    queryFn: fetchBilling,
    select: (data): BillingSummary => {
      const filtered = data.dailyUsage.filter(
        (item) => item.date >= dateRange.from && item.date <= dateRange.to,
      );
      const consumedMinutes = filtered.reduce((acc, item) => acc + item.minutes, 0);
      return { dailyUsage: filtered, consumedMinutes };
    },
  });
